import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-api-loader',
  template: `<mat-spinner diameter="50"></mat-spinner>`,
  styleUrls: ['./api-loader.component.scss'],
})
export class ApiLoaderComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
